import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../../Radio'
import { NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE } from '../NewsboardPostForm.constants'

import { INITIAL_VALUES } from './TemplateConfirmationModal.constants'
import { getOptions } from './TemplateConfirmationModal.utils'

function TemplateConfirmationModal(props) {
  const { t } = useTranslation()

  return (
    <RadioGroupModal
      {...props}
      formFieldsProps={{
        getOptions,
        name: NEWSBOARD_POST_FORM_FIELD_NAME_INSERT_REPLACE,
        title: t('Modal.InsertReplaceTemplateConfirmationModalTextKey'),
      }}
      initialValues={INITIAL_VALUES}
      title={t('Modal.InsertReplaceTemplateConfirmationModalTitleKey')}
    />
  )
}

export default TemplateConfirmationModal
